<div class="display">

  @if (simulation.pet.type === 'dog') {
    <app-dog-display></app-dog-display>
  }

  @if (simulation.pet.type === 'cat') {
    <app-cat-display></app-cat-display>
  }

</div>

